import { EmployerEditWizard } from "@js/apps/employer/components/employer-edit-wizard";

import { EmployerTeamMembersLazy } from "../../lazy";

export const EmployerTeamMembersPage = () => {
  return (
    <EmployerEditWizard pageTitle="Edit Profile | Team Members">
      <EmployerTeamMembersLazy />
    </EmployerEditWizard>
  );
};
